import * as Constants from './constants'

export const nganhHangListRequest = function nganhHangListRequest(formData) {
  return {
    type: Constants.NGANHHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const nganhHangListSuccess = function nganhHangListSuccess(data) {
  return {
    type: Constants.NGANHHANG_LIST_SUCCESS,
    data
  }
}

export const nganhHangListError = function nganhHangListError(error) {
  return {
    type: Constants.NGANHHANG_LIST_ERROR,
    error
  }
}

export const nganhHangDetailRequest = function nganhHangDetailRequest(formData) {
  return {
    type: Constants.NGANHHANG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const nganhHangDetailSuccess = function nganhHangDetailSuccess(data) {
  return {
    type: Constants.NGANHHANG_DETAIL_SUCCESS,
    data
  }
}

export const nganhHangDetailError = function nganhHangDetailError(error) {
  return {
    type: Constants.NGANHHANG_DETAIL_ERROR,
    error
  }
}

export const nganhHangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.NGANHHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nganhHangUpdateSuccess = function nganhHangUpdateSuccess(response) {
  return {
    type: Constants.NGANHHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const nganhHangUpdateError = function nganhHangUpdateError(error) {
  return {
    type: Constants.NGANHHANG_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/NganhHang/actions.js